import { render } from "./openOrderDetail.vue?vue&type=template&id=02ae03aa&scoped=true"
import script from "./openOrderDetail.vue?vue&type=script&lang=js"
export * from "./openOrderDetail.vue?vue&type=script&lang=js"

import "./openOrderDetail.vue?vue&type=style&index=0&id=02ae03aa&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ae03aa"]])

export default __exports__